import api from "../index";

export const GetAllKycApi = (params) => api.get(`Admin/GetAll-UserKyc?${params}`);
export const GetAllKycByIdApi = (kycId) => api.get(`Admin/GetSingleKYC/${kycId}`);
export const KycRequestAcceptRejectApi = (data) => api.post('Admin/UserRejected-ApprovedKyc', data);
export const UploadUserKycApi = (data) => api.post('Admin/Upload-UserKyc', data, {
  headers: { Accept: "application/json", "Content-Type": "multipart/form-data" }
});
export const GetUserKycHistoryApi = (userId) => api.get(`Admin/GetUserKycHistory/${userId}`);
export const UpdateUserFullyKycApi = (data) => api.post('Admin/Update-UserFullyKyc', data);